import { Col, Drawer, Menu, Row, Typography } from 'antd'
import ChilizNFTLogo from '../assets/images/logo.png'
import { ReactComponent as BarsIcon } from '../assets/icons/Bars.svg'
import Icon, { CloseOutlined } from '@ant-design/icons'
import { ConnectionIndicator } from './ConnectionIndicator'
import { SelectChain } from './SelectChain'
import { chains, IChainConfig } from '../config/chains'
import { ReactComponent as ConnectIconSvg } from '../assets/icons/Connect.svg'
import { useChilizConfigProvider, useChilizStore } from '../stores'
import { Content } from 'antd/es/layout/layout'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { observer } from 'mobx-react'

const { Item, ItemGroup } = Menu

export const MobileMenu = observer((): JSX.Element => {
  const store = useChilizStore()
  const configProvider = useChilizConfigProvider()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const toggleMobileMenuOpen = (): void => {
    setMobileMenuOpen(!mobileMenuOpen)
  }
  const onChangeChain = async (chainId): Promise<void> => {
    await store.addNetworkToMetaMask(chains.find(chain => chain.chainId === chainId) as IChainConfig)
  }
  return (
      <Content>
        <Row align={'middle'} style={{ padding: '10px' }}>
          <Col style={{ marginLeft: 'auto' }}>
            <NavLink to={''} rel="noreferrer"><img src={ChilizNFTLogo} alt="Chiliz NFTs" style={{ height: '5rem' }} /></NavLink>
          </Col>
          <Col style={{ justifyContent: 'flex-end', marginLeft: 'auto' }}>
            {!mobileMenuOpen && <BarsIcon onClick={() => toggleMobileMenuOpen()}/>}
            {mobileMenuOpen && <CloseOutlined onClick={() => toggleMobileMenuOpen()}/>}
          </Col>
        </Row>
        <div>
          <Drawer
            placement='top'
            onClose={toggleMobileMenuOpen}
            visible={mobileMenuOpen}
            getContainer={false}
            closable={false}
            className={mobileMenuOpen ? 'drawer-wrapper' : ''}
            bodyStyle={{ background: '#232E3E', paddingTop: 0 }}
            contentWrapperStyle={{ height: 'auto' }}>
            <Menu className={'mobile-menu-open'}>
              <ItemGroup>
                {store.isConnected &&
                  <>
                    <Item>
                      <ConnectionIndicator/>
                    </Item>
                    <Item>
                      <SelectChain defaultValue={configProvider.getChainConfig().chainName}
                                   chains={chains}
                                   className={'chain-select'}
                                   onChange={async (chain) => await onChangeChain(chain)}/>
                    </Item>
                  </>
                }
                <Item>
                  <NavLink to={'/collections'}
                           rel="noreferrer"
                           className={({ isActive }) =>
                             isActive ? 'menu-link-active' : 'menu-link'
                           }>
                    <Typography.Text>BROWSE COLLECTIONS</Typography.Text>
                  </NavLink>
                </Item>
                <Item>
                  {store.isConnected && <NavLink to={'/my-wallet'}
                                                 rel="noreferrer"
                                                 className={({ isActive }) =>
                                                   isActive ? 'menu-link-active' : 'menu-link'
                                                 }>
                    <Typography.Text>MY WALLET</Typography.Text>
                  </NavLink>}
                  {!store.isConnected && <SelectChain defaultValue={'CONNECT WALLET'}
                                                      chains={chains}
                                                      className={'chain-select connect'}
                                                      suffixIcon={
                                                        <Icon component={ConnectIconSvg}
                                                              style={{
                                                                fill: '#fff',
                                                                color: '#fff',
                                                                fontSize: '24px',
                                                                lineHeight: '24px',
                                                                verticalAlign: 'middle'
                                                              }}/>}
                                                      onChange={async (chain) => await onChangeChain(chain)}/>
                  }
                </Item>
              </ItemGroup>
            </Menu>
          </Drawer>
        </div>
      </Content>)
}
)
